import { FormEvent, useContext, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logoLogin from "../../assets/images/LOGO_TNS_RGB-1.png";
import ModeButton from "../../components/ModeButton";
import ErrorLoginModal from "../../components/WarningModal/login";
import { AuthContext } from "../../contexts/Authentication/AuthContext";
import "./styles.css";

const Login = () => {
  const [code, setCode] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const { signIn } = useContext(AuthContext);

  const handleLoginSubmit = (e: FormEvent) => {
    e.preventDefault();
    signIn({ code, username, password });
  };
  
  useEffect(() => {
  document.title = 'Torre Logística de Entregas - TLE';
  },[])

  return (
    <div>
      <div className="background-login">
        <div className="content-login">
          <div className="display-flex-center">
            <ModeButton />
          </div>
          <div className="text-center mb-3">
            <h1 style={{ fontWeight: "bold" }}>Torre Logística de Entregas</h1>
            <div className="login-logo">
              <img
                src={logoLogin}
                alt="Logo TNS"
                className="login-logo-img"
              />
              <p className="login-logo-subtitle">Gestão de Entregas</p>
            </div>
          </div>
          <form onSubmit={handleLoginSubmit} className="form-login">
            <input
              type="code"
              placeholder="Conta"
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
            <input
              type="username"
              placeholder="Usuário"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <input
              type="password"
              placeholder="Senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <div className="button-login display-flex-center">
              <Button type="submit" value="submit" variant="primary">
                Entrar
              </Button>
            </div>
          </form>
        </div>
        <ToastContainer />
        <ErrorLoginModal/>
      </div>
    </div>
  );
};

export default Login;
